import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Theme } from '@material-ui/core';
import { classPrefix } from './types';

/**
 * Material UI styles have high specificity than the style.module.css classes, so modifications should be done here
 */
export function getMaterialStyles(useReversedColors: boolean, useClassPrefix = true) {

  const pref = useClassPrefix ? `${classPrefix}-` : '';
  return makeStyles((theme: Theme) => {
    const s: any = {
      selectFC: {
        width: 100,
      },
      select: {
        paddingLeft: 3,
      },
      inputLabel: {
        // transform: 'translateY(16px)',
        // padding: '0 5px'
      },
      menuItem: {
        padding: '6px 10px',
        [`&.Mui-selected`]: {
          backgroundColor: theme.palette.primary.main + ' !important',
          color: 'white !important',
        },
        ['&:hover']: {
          backgroundColor: theme.palette.primary.light,
          color: 'white',
        }
      },
      // textField: {}
    };

    if (useReversedColors) {
      const LIGHT_WHITE = 'rgba(255,255,255,0.6) !important';
      s.inputLabel.color = 'white';

      // s.textField = {
      //   [`& .${pref}MuiFormLabel-root`]: {
      //     color: 'white',
      //   },
      //   [`& .${pref}MuiInput-input`]: {
      //     color: 'black', // this gets inverted to white
      //     filter: 'invert(1)', // need to use invert to get the clock icon to change to white
      //   },
      //   [`& .${pref}MuiInputBase-root:before`]: {
      //     borderBottomColor: 'rgba(255,255,255,0.5)',
      //   },
      //   [`& .${pref}MuiInput-underline:hover:not(.Mui-disabled):before`]: {
      //     borderBottomColor: LIGHT_WHITE,
      //   },
      //   [`& .${pref}MuiInput-underline:hover:not(.Mui-disabled):after`]: {
      //     borderBottomColor: 'white',
      //   },
      // };
      s.select.color = 'white';

      s.select[`& .${pref}MuiFormControl-root`] = {
        color: 'white',
      };
      s.selectFC[`& .${pref}MuiInput-root:before`] = {
        borderBottomColor: LIGHT_WHITE,
      };

      s.selectFC[`& .${pref}MuiInput-underline:after`] = {
        borderBottomColor: 'white',
      };
      s.selectFC[`& label.${pref}MuiInputLabel-root`] = {
        color: 'white',
      };
      s.selectFC[`& label.${pref}MuiInputLabel-root.Mui-focused`] = {
        color: 'white',
      };
      s.selectFC[`& .${pref}MuiSvgIcon-root`] = {
        fill: 'white',
      };
    }

    return createStyles(s);
  });
}
